module.exports = __webpack_public_path__ + "img/c01_unitballistatrireme_Normal_ua.c35de89c.webp";